export default "__VITE_ASSET__1459f65b__"